import { ZendropConfig } from '@server/types/configs';
import { createGlobalConfig } from '@wix/panorama-client-web';

declare global {
  interface Window {
    __ENV__: string;
    __LOCALE__: string;
    __MESSAGES__: any;
    __BASEURL__: string;
    __ARTIFACT_VERSION__: string;
    __USER_ID__?: string;
    __BI_LOGGER_HOST__?: string;
    __EXPERIMENTS__?: any;
    __INITIAL_STATE__?: import('@common/types').InitialState;
    __GEO__: string;
    Sentry?: typeof import('@sentry/browser');
    __ZENDROP__: ZendropConfig;
  }
}

export type ChatWidgetTheme = 'light' | 'dark';

const theme: ChatWidgetTheme = 'light';

export const config = {
  env: window.__ENV__,
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__ || {},
  baseUrl: window.__BASEURL__,
  artifactVersion: window.__ARTIFACT_VERSION__,
  userId: window.__USER_ID__,
  biLoggerHost: window.__BI_LOGGER_HOST__,
  experiments: window.__EXPERIMENTS__ || {},
  initialState: window.__INITIAL_STATE__,
  geo: window.__GEO__,
  zendrop: window.__ZENDROP__,
  overrideLocale:
    new URLSearchParams(window.location.search).get('overrideLocale') ||
    new URLSearchParams(window.location.search).get('overridelocale') ||
    undefined,
  theme,
};

export const panoramaGlobalConfig = createGlobalConfig();
